import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../Utilities/PaginationNew';
import InputSearch from '../Utilities/InputSearch';
import AlertSwitch from '../Utilities/AlertSwitch/EnterpriseAlertSwitch';
import { selectLeftNavigate } from '../../store/slice/navigate';
import styles from './style/Enterprise.module.scss';
import InnerLayout from '../Layout/InnerLayout';
import Button from '../Utilities/Button';
import { getLanguage, selectMultilingual, updateLanguage } from '../../store/slice/language/multilingual';

const Enterprise = () => {
  const dispatch = useDispatch();

  const { language } = useSelector(selectMultilingual);

  const toggleLeftNavigation = useSelector(selectLeftNavigate);
  const leftNavigationShow = toggleLeftNavigation.toggleOpen;

  const [page, setPage] = useState(1);
  const [fetchSearchValue, setFetchSearchValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const limit = 10;

  useEffect(() => {
    dispatch(getLanguage({ limit: limit, page: page, search: searchValue }));
  }, [dispatch, limit, page, searchValue]);

  const pageChangeHandler = (e) => {
    setPage(parseInt(e.selected + 1));
  };

  const handleSearch = (e) => {
    if (e.code === 'Enter' || e.charCode === 13) {
      setSearchValue(fetchSearchValue);
      setPage(1);
    }
  };

  const handleStatus = (item) => {
    const postObj = {
      id: item.id,
      active: !item.active,
    };
    dispatch(updateLanguage(postObj)).then(() => dispatch(getLanguage({ limit: limit, page: page, search: searchValue })));
  };

  return (
    <InnerLayout>
      <>
        <div className={`${styles.dashboardOuter} ${!leftNavigationShow && styles.leftNavigationShow}`}>
          <div className={styles.header}>語言設定</div>

          <div className={styles.body}>
            <div className={styles.bodyTitle}>
              <div>語言列表</div>
              <div className={styles.searchBlock}>
                <InputSearch
                  placeholder='搜尋文章名稱'
                  value={fetchSearchValue}
                  width={'150px'}
                  height={'24px'}
                  onKeyPress={(e) => handleSearch(e)}
                  onChange={(e) => setFetchSearchValue(e.target.value)}
                  clickSearchIcon={() => {}}
                  onClear={() => {
                    setSearchValue('');
                    setFetchSearchValue('');
                  }}
                />
                <Button
                  type='primary'
                  onClick={() => {
                    setFetchSearchValue(searchValue);
                    setPage(1);
                  }}
                  title='搜尋'
                />
              </div>
            </div>
            <Pagination
              onPageChange={(e) => {
                pageChangeHandler(e);
              }}
              pageCount={page}
              totalData={language?.total}
              totalPages={Math.ceil(language?.total / limit)}
              limit={limit}
            />
            {language?.total === 0 && <div className={styles.noDataContainer}>目前無案例</div>}
            {language?.total !== 0 && (
              <div className={styles.tableContainer}>
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '25%' }}>語言名稱 (中文)</th>
                      <th style={{ width: '25%' }}>語言名稱</th>
                      <th style={{ width: '25%' }}>代碼</th>
                      <th style={{ width: '25%' }}></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {language?.rows?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td style={{ width: '25%' }}>{item.name}</td>
                          <td style={{ width: '25%' }}>{item.language}</td>
                          <td style={{ width: '25%' }}>{item.code}</td>
                          <td style={{ width: '25%' }}>
                            <AlertSwitch isChecked={item.active} onChange={() => handleStatus(item)} />
                          </td>
                          <td className={styles.iconContent}></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </>
    </InnerLayout>
  );
};

export default Enterprise;
